module.exports = __webpack_public_path__ + "img/icon-meal-plan-grey.2d4719e5.svg";